import React, { useEffect, useState } from "react";
import InsightTable from "../InsightTable";
import { transformResultsToTableData } from "../../../../services/commonService";

function AdoptionMarketResponse({ adoptionAndMarketResponse }) {
  const [tabData, setTabData] = useState([]);

  const actions = [
    // { type: "chart", title: "Chart", onClick: () => {} },
    { type: "conversation", title: "Conversation", onClick: () => {} },
    { type: "mindMap", title: "Mind Map", onClick: () => {} },
    { type: "download", title: "Download", onClick: () => {} },
  ];

  // const dummyData = [
  //   {
  //     competitor: "a",
  //     early_sales_feedback: "b",
  //     customer_interest: "c",
  //     competitive_response: "d",
  //     early_sales_feedback_positive_insight: "b",
  //     early_sales_feedback_negative_insight: "b",
  //     early_sales_feedback_recent_development: "b",
  //     customer_interest_positive_insight: "c",
  //     customer_interest_negative_insight: "c",
  //     customer_interest_recent_development: "c",
  //     competitive_response_positive_insight: "d",
  //     competitive_response_negative_insight: "d",
  //     competitive_response_recent_development: "d",
  //   },
  //   {
  //     competitor: "a",
  //     early_sales_feedback: "b",
  //     customer_interest: "c",
  //     competitive_response: "d",
  //     early_sales_feedback_positive_insight: "b",
  //     early_sales_feedback_negative_insight: "b",
  //     early_sales_feedback_recent_development: "b",
  //     customer_interest_positive_insight: "c",
  //     customer_interest_negative_insight: "c",
  //     customer_interest_recent_development: "c",
  //     competitive_response_positive_insight: "d",
  //     competitive_response_negative_insight: "d",
  //     competitive_response_recent_development: "d",
  //   },
  //   {
  //     competitor: "a",
  //     early_sales_feedback: "b",
  //     customer_interest: "c",
  //     competitive_response: "d",
  //     early_sales_feedback_positive_insight: "b",
  //     early_sales_feedback_negative_insight: "b",
  //     early_sales_feedback_recent_development: "b",
  //     customer_interest_positive_insight: "c",
  //     customer_interest_negative_insight: "c",
  //     customer_interest_recent_development: "c",
  //     competitive_response_positive_insight: "d",
  //     competitive_response_negative_insight: "d",
  //     competitive_response_recent_development: "d",
  //   },
  // ];

  useEffect(() => {
    const tableData = transformResultsToTableData(adoptionAndMarketResponse);
    setTabData(tableData);
  }, [adoptionAndMarketResponse]);

  const tableColumns = [
    // { key: "competitor", label: "Competitor" },
    { key: "early_sales_feedback", label: "Early Sales Feedback" },
    { key: "customer_interest", label: "Customer Interest" },
    { key: "competitive_response", label: "Competitive Response" },
  ];

  return (
    <InsightTable
      title="Adoption & Market Response"
      subtitle="Evaluates customer interest, adoption patterns, and competitor response following recent product launches across the healthcare supply landscape."
      data={tabData}
      metrics={tableColumns}
      rowIdentifier="competitor"
      actions={actions}
    />
  );
}

export default AdoptionMarketResponse;
